/* istanbul ignore file */

// eslint-disable-next-line import/prefer-default-export
export const AMPLIFY_AUTH_NOT_INSTALLED_ERROR_MESSAGE =
    "No Auth module found, please ensure @aws-amplify/auth is installed";
